import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/store";
import i18n from "./plugins/i18n";
import vuetify from "./plugins/vuetify";
import "./css/style.css";
import "chart.js";
import "chartjs-plugin-datalabels";
import Notifications from "vue-notification";

Vue.use(Notifications);

import Vue2TouchEvents from "vue2-touch-events";
Vue.use(Vue2TouchEvents);

Vue.config.productionTip = false;
Vue.config.devtools = true;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
